import { Product, PRODUCTS } from "data/data";
import { FC, Fragment, useState } from "react";
import { Dialog, Popover, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from "react-router-dom";
import Item from "./Item";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Avatar from "shared/Avatar/Avatar";
import { avatarImgs } from "contains/fakeData";
import SwitchDarkMode2 from "shared/SwitchDarkMode/SwitchDarkMode2";
import { HeartIcon, MessageIcon, NotificationIcon, UserIcon } from "components/icons";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "app/authorizationReducers";
import { Notification } from "app/helpers/sendnotification";
import { RootState } from "app/store";
import { UserState } from "containers/PageLogin/PageLogin";

const AvatarSlide = () =>{
    const [open, setOpen] = useState<boolean>(false)
    const slideHndeler = () => {
        setOpen(true)
    }
    const userLogin = useSelector<RootState, UserState>( (state: RootState) => state.authorizationReducer )


    const {loggedIn, user} = userLogin
  
    
    const dispatch = useDispatch()
    const logOutHendler = () =>{
  
      dispatch(logout({}))
      Notification('success', "Vous êtes maintenant déconnecté!")
    }
    return (
        <Popover>
                    <Popover.Button
                    onClick={slideHndeler}
            className={`
                
                 group w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full inline-flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 relative`}
          > {loggedIn ?
            <div className="w-3.5 h-3.5 flex items-center justify-center bg-primary-500 absolute top-1.5 right-1.5 rounded-full text-[10px] leading-none text-white font-medium">
              <span className="mt-[1px]">3</span>
            </div>
            :  <Link className="block  absolute inset-0" to={"/login"} />}
            <UserIcon></UserIcon>

           
          </Popover.Button>
          {loggedIn ?
            <Transition.Root show={open} as={Fragment}>
        
                <Dialog as="div" className="relative z-40 " onClose={setOpen}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className=" fixed inset-0 overflow-hidden ">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10  ">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <Dialog.Panel className="pointer-events-auto w-screen max-w-md  ">
                            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl dark:bg-slate-900 text-slate-900 dark:text-slate-200">
                                <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                <div className="flex items-start justify-between">
                                    <Dialog.Title className="text-lg font-medium text-gray-900  dark:text-slate-200">
                                    <div className="flex items-center space-x-3">
                                        <Avatar imgUrl={`${ process.env.REACT_APP_API_URL}/api/media/avatar/${user.username}`} sizeClass="w-12 h-12" />

                                        <div className="flex-grow">
                                            <h4 className="font-semibold">{user?.firstname} {user?.lastname}</h4>
                                            <p className="text-xs mt-0.5">{user.email}</p>
                                        </div>
                                    </div>
                                    </Dialog.Title>
                                    <div className="ml-3 flex h-7 items-center">
                                    <button
                                        type="button"
                                        className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Close panel</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                    </div>
                                </div>

                                <div className="mt-8">
                                    <div className="flow-root">
                                    <ul role="list" className="">
                                         {/* ------------------ 1 --------------------- */}
                                        <li className="py-5">
                                        
                                            <Link
                                                to={"/dash/notifications"}
                                                className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                                                onClick={() => setOpen(false)}
                                                >
                                                <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                    <NotificationIcon/>
                                                </div>
                                                <div className="ml-4">
                                                    <p className="text-sm font-medium ">{"Notifications"}</p>
                                                </div>
                                                </Link>

                                        </li>
                                        <li className="py-5">
                                        
                                            <Link
                                                to={"/dash/account"}
                                                className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                                                onClick={() => setOpen(false)}
                                                >
                                                <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                    <UserIcon/>
                                                </div>
                                                <div className="ml-4">
                                                    <p className="text-sm font-medium ">{"Mon compte"}</p>
                                                </div>
                                                </Link>

                                        </li>
                                        <li className="py-5">
                                           {/* ------------------ 2 --------------------- */}
                                                <Link
                                                to={"/dash/messages"}
                                                className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                                                onClick={() => setOpen(false)}
                                                >
                                                <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                    <MessageIcon />
                                                </div>
                                                <div className="ml-4">
                                                    <p className="text-sm font-medium ">{"Messages"}</p>
                                                </div>
                                                </Link>

                                        </li>
                                                {/* ------------------ 2 --------------------- */}
                                        <li className="py-5">
                                                <Link
                                                to={"/dash/wishlist"}
                                                className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                                                onClick={() => setOpen(false)}
                                                >
                                                <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                    <HeartIcon/>
                                                </div>
                                                <div className="ml-4">
                                                    <p className="text-sm font-medium ">{"Wishlist"}</p>
                                                </div>
                                                </Link>
                                        </li>
                                 
                                     
                                    </ul>
                                    </div>
                                </div>
                                </div>
                                <div className="w-full border-b border-neutral-200 dark:border-neutral-700" />
                                <div className=" px-4 py-6 sm:px-6">
                                    <div className=" text-base font-medium text-gray-900">
                                        <ul className="dark:text-slate-200">
                                            <li className="py-5">
                                                <div className="flex items-center justify-between p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50">
                                                    <div className="flex items-center">
                                                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                            d="M12.0001 7.88989L10.9301 9.74989C10.6901 10.1599 10.8901 10.4999 11.3601 10.4999H12.6301C13.1101 10.4999 13.3001 10.8399 13.0601 11.2499L12.0001 13.1099"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            />
                                                            <path
                                                            d="M8.30011 18.0399V16.8799C6.00011 15.4899 4.11011 12.7799 4.11011 9.89993C4.11011 4.94993 8.66011 1.06993 13.8001 2.18993C16.0601 2.68993 18.0401 4.18993 19.0701 6.25993C21.1601 10.4599 18.9601 14.9199 15.7301 16.8699V18.0299C15.7301 18.3199 15.8401 18.9899 14.7701 18.9899H9.26011C8.16011 18.9999 8.30011 18.5699 8.30011 18.0399Z"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            />
                                                            <path
                                                            d="M8.5 22C10.79 21.35 13.21 21.35 15.5 22"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                        </div>
                                                        <div className="ml-4">
                                                        <p className="text-sm font-medium ">{"Dark theme"}</p>
                                                        </div>
                                                    </div>
                                                    <SwitchDarkMode2 />
                                                </div>
                                            </li>
                                            <li className="py-5">
                                                <Link
                                            to={"/#"}
                                            className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                                            onClick={() => setOpen(false)}
                                            >
                                            <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                >
                                                <path
                                                    d="M11.97 22C17.4928 22 21.97 17.5228 21.97 12C21.97 6.47715 17.4928 2 11.97 2C6.44715 2 1.97 6.47715 1.97 12C1.97 17.5228 6.44715 22 11.97 22Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M4.89999 4.92993L8.43999 8.45993"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M4.89999 19.07L8.43999 15.54"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M19.05 19.07L15.51 15.54"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M19.05 4.92993L15.51 8.45993"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                </svg>
                                            </div>
                                            <div className="ml-4">
                                                <p className="text-sm font-medium ">{"Help"}</p>
                                            </div>
                                                </Link>
                                            </li>
                                            <li className="py-5">
                                            <Link
                                                to={"/#"}
                                                className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                                                onClick={() => {logOutHendler(); setOpen(false)}}
                                                >
                                                <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                                                    <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                    <path
                                                        d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
                                                        stroke="currentColor"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M15 12H3.62"
                                                        stroke="currentColor"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
                                                        stroke="currentColor"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    </svg>
                                                </div>
                                                <div className="ml-4" >
                                                    <p className="text-sm font-medium " >{"Se déconnecter"}</p>
                                                </div>
                                                </Link>
                                            </li>
                                        </ul>
                                      
                                        {/* ------------------ 2 --------------------- */}
                                        

                                        {/* ------------------ 2 --------------------- */}
                                        
                                    </div>
                               
                         
                             
                                </div>                    
                              
                            </div>
                            </Dialog.Panel>
                        </Transition.Child>
                        </div>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
          : null}
        </Popover>
    )
}

export default  AvatarSlide;